import _ from 'underscore';
import { Subtract } from 'utility-types';

import { FilterUpdaterOwnProps, withFilterUpdater } from '~src/spacesPlatform/components/Explorer/helpers/FilterUpdater';
import { SortOrderUpdaterOwnProps, withSortOrderUpdater } from '~src/spacesPlatform/components/Explorer/helpers/SortOrderUpdater';

import { ConnectedPredictiveModelViewerSpace } from './ConnectedPredictiveModelViewerSpace';
import {
  InjectedPredictiveModelSpaceDataFetcherProps,
  PredictiveModelSpaceDataFetcherProps,
  withPredictiveModelSpaceDataFetcher
} from './PredictiveModelSpaceDataFetcher';
import {
  InjectedPredictiveModelSpaceServiceInjectorProps,
  PredictiveModelSpaceServiceInjectorProps,
  withPredictiveModelSpaceServiceInjector
} from './PredictiveModelSpaceServiceInjector';
import { PredictiveModelViewerSpaceOwnProps } from './PredictiveModelViewerSpace';

export type PredictiveModelSpaceProviderProps = FilterUpdaterOwnProps
  & SortOrderUpdaterOwnProps
  & PredictiveModelSpaceDataFetcherProps
  & PredictiveModelSpaceServiceInjectorProps
  & Subtract<Subtract<PredictiveModelViewerSpaceOwnProps, InjectedPredictiveModelSpaceDataFetcherProps>, InjectedPredictiveModelSpaceServiceInjectorProps>;

export const PredictiveModelViewerSpaceProvider: React.ComponentType<PredictiveModelSpaceProviderProps> = _.compose(
  withFilterUpdater,
  withSortOrderUpdater,
  withPredictiveModelSpaceDataFetcher,
  withPredictiveModelSpaceServiceInjector,
)(ConnectedPredictiveModelViewerSpace);
